<template>
    <div>
        <div id="sub-header" v-if="mobile">
            <div class="container">
                <div class="flex flex-center">
                    <div class="top_mobile_sub">
                        <div class="logo hondacommunity"><a :href="app_url"><img
                                    :src="cdn_url+'/assets/community/images/logo_community.png'" alt="logo"></a></div>
                        <div class="list-socmed">
                            <a target="_blank" @click="gtmTrackerShare('Follow Social Media', 'Facebook', 1)"
                                href="https://facebook.com/hondacomm" class="icon-socmed"><i
                                    class="fa fa-facebook-official" aria-hidden="true"></i></a>
                            <a target="_blank" @click="gtmTrackerShare('Follow Social Media', 'Twitter', 2)"
                                href="https://twitter.com/hondacomm" class="icon-socmed"><i class="fa fa-twitter-square"
                                    aria-hidden="true"></i></a>
                            <a target="_blank" @click="gtmTrackerShare('Follow Social Media', 'Instagram', 3)"
                                href="https://www.instagram.com/honda.community/" class="icon-socmed"><i
                                    class="fa fa-instagram" aria-hidden="true"></i></a>
                            <a target="_blank" @click="gtmTrackerShare('Follow Social Media', 'Youtube', 4)"
                                href="https://www.youtube.com/user/hondacommunity" class="icon-socmed"><i
                                    class="fa fa-youtube-play" aria-hidden="true"></i></a>
                        </div>
                    </div>
                    <div class="rightSub">
                        <div class="button bordered">
                            <a @click="backTracker" class="back-button" :href="main_site_url">
                                <img :src="cdn_url+'/assets/community/images/back-arrow.svg'" alt="Kembali ke MainSite">
                                Kembali ke MainSite</a>
                        </div>
                        <div class="button" v-if="login">
                            <a class="red-button" :href="app_url+'/hcid'">Profile HCID</a>

                        </div>
                        <div class="button" v-else>
                            <a class="red-button" @click="gotoLoginPage">Daftar/Login HCID</a>
                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div id="sub-header" v-else>
            <div class="container">
                <div class="flex flex-center">
                    <div class="logo hondacommunity"><a :href="app_url"><img
                                :src="cdn_url+'/assets/community/images/logo_community.png'" alt="logo"></a></div>
                    <div class="rightSub">
                        <div class="button bordered">
                            <a @click="backTracker" class="back-button" :href="main_site_url">
                                <img :src="cdn_url+'/assets/community/images/back-arrow.svg'" alt="Kembali ke MainSite">
                                Kembali ke MainSite</a>
                        </div>
                        <div class="button" v-if="login">
                            <a class="red-button" @click="logoutApp">Logout</a>
                        </div>
                        <div class="button" v-else>
                            <a class="red-button" @click="gotoLoginPage">Daftar/Login HCID</a>
                        </div>
                        <div class="list-socmed">
                            <a target="_blank" @click="gtmTrackerShare('Follow Social Media', 'Facebook', 1)"
                                href="https://facebook.com/hondacomm" class="icon-socmed"><i
                                    class="fa fa-facebook-official" aria-hidden="true"></i></a>
                            <a target="_blank" @click="gtmTrackerShare('Follow Social Media', 'Twitter', 2)"
                                href="https://twitter.com/hondacomm" class="icon-socmed"><i class="fa fa-twitter-square"
                                    aria-hidden="true"></i></a>
                            <a target="_blank" @click="gtmTrackerShare('Follow Social Media', 'Instagram', 3)"
                                href="https://www.instagram.com/honda.community/" class="icon-socmed"><i
                                    class="fa fa-instagram" aria-hidden="true"></i></a>
                            <a target="_blank" @click="gtmTrackerShare('Follow Social Media', 'Youtube', 4)"
                                href="https://www.youtube.com/user/hondacommunity" class="icon-socmed"><i
                                    class="fa fa-youtube-play" aria-hidden="true"></i></a>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';

export default	{
	data: function() {
		return{
            cdn_url: cdn_url,
            base_url:'',
            app_url:'',
            api_url:'',
            main_site_url:'',
			isMobile: isMobile,
			mobile: false,
            login:auth,
            user:null
		}
	},
	created(){
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.main_site_url = main_site_url;
		this.mobile = isMobile;
	},
    methods:{
		gtmTrackerShare(action, lable, position) {
            var data = {
                'event': 'followSocial',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': action,
                'eventDetail.label': lable,
                'position': position,
            };
			dataLayer.push(data);
		},
		gotoLoginPage(){
            localStorage.clear();
            var trackerLogin = {
                'event': "daftarLoginClick",
                'eventDetail.category' : "Custom Event",
                'eventDetail.action' : "Daftar Login Click",
                'eventDetail.label' : window.location.href,
            }
            dataLayer.push(trackerLogin);
			window.location.href = app_url+'/login';
		},
        backTracker() {
            var dataTracker = {
                'event': "backToMainsiteClick",
                'eventDetail.category': "Custom Event",
                'eventDetail.action': "Back to Mainsite Click",
                'eventDetail.label': window.location.href,
            }
            dataLayer.push(dataTracker);
        },
        logoutApp(){
            localStorage.clear();
            var dataTracker = {
                'event': "logOutClick",
                'eventDetail.category': "Custom Event",
                'eventDetail.action': "Logout Click",
                'eventDetail.label': window.location.href
            }
            dataLayer.push(dataTracker);
			window.location.href = app_url+'/logout';
        }
    }
}


</script>

<style lang="scss" scoped>
	#sub-header{
	    padding: 1.5em 0;
	    position: relative;
	    z-index: 10;
		background: url(/community/images/bg_header.png) no-repeat center center;
        background-color: #000;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
	}
	.rightSub{
		margin-left:auto;
		text-align:right;
	}
    .button.bordered{
        margin-right: 20px ;
        padding-right: 20px;
		border-right:1px solid rgba(255,255,255,0.3);
        a{
        color:#fff;
        font-size: 16px;
        }
        img{
            width: 24px;
            margin-right: 5px;
        }
    }
	.red-button{
		background-color: #E61B33;
		color: #fff;
		padding: 10px 20px;
		border-radius: 10px;
		font-weight: 700;
		font-size: 14px;
		display: inline-block;
        cursor: pointer;
	}
	.button,.list-socmed{
		display:inline-block;
	}
	.red-button:hover{
		background-color:#282828;
	}
	.list-socmed a:hover{
		color:#E61B33;
	}
	.list-socmed{
		padding-left:10px;
		margin-left:10px;
		border-left:1px solid rgba(255,255,255,0.3);
	}
	.list-socmed a{
		font-size:24px;
		color:#fff;
		margin: 0 5px;
	}

@media all and (max-width:767px){
    .rightSub{
        display:flex;
    }
    .button.bordered{
        a{
        font-size: 14px;
        }
        img{
            width: 18px;
        }
    }
	.top_mobile_sub{
	    display:flex;
	    width:100%;
	    align-items:center;
	    justify-content: space-between;
	    padding-bottom:5px;
	    margin-bottom:15px;
	    border-bottom: 1px solid rgba(255,255,255,0.3);
	}
	.list-socmed{
		border-left:none
	}
	.logo.hondacommunity{
		max-width:170px;
	}
	.red-button{
	    background-color: #E61B33;
	    color: #fff;
	    padding: 5px 20px;
	    border-radius: 10px;
	    font-weight: 700;
	    font-size: 13px;
	    display: inline-block;
    }

}

</style>
